import { Directive, Input, OnChanges, OnDestroy, SimpleChanges, TemplateRef, ViewContainerRef } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { AuthService } from "src/app/modules/auth/services/auth.service";
import { SubRole, UserModel } from "../interfaces/user";

@Directive({
  selector: '[appSubRole]',
})
export class SubRoleDirective implements OnChanges, OnDestroy {
  @Input() appSubRole!: SubRole[];

  private currentUser!: UserModel;
  private destroy$ = new Subject<void>();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {
    this.authService.user$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.currentUser = user;
        if (this.appSubRole) this.updateView();
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appSubRole']) this.updateView();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateView(): void {
    if (!this.appSubRole || this.appSubRole.length === 0) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }

    const hasAccess = this.checkAccess();
    hasAccess ? this.viewContainer.createEmbeddedView(this.templateRef) : this.viewContainer.clear();
  }

  private checkAccess(): boolean {
    const user = this.currentUser;
    if (!user) return false;

    // Parent account (isSubUser === false) always has full access
    if (!user.isSubUser) return true;

    // Sub-user: check if any of the user's subRoles match the required roles
    return user.subRoles?.some(role =>
      this.appSubRole.includes(role as SubRole)
    ) ?? false;
  }
}
